export function LegendPie({ color }: { color: string }) {
	return (
		<svg fill="none" height="16" viewBox="0 0 3 16" width="3" xmlns="http://www.w3.org/2000/svg">
			<title>Pie chart image</title>
			<rect fill={color} height="16" rx="1.5" width="3" />
		</svg>
	);
}
